// GENERATED by scripts/gen-flags.mjs from server/flags/registry.js — do not edit.
// `node scripts/gen-flags.mjs --check` (scripts/check.sh --step gen-flags) fails when this is stale.

/** The deployment flags hooks/useAuthSession.ts holds as one object, by client name. */
export type Flags = {
  _debugUIAllowed: boolean;
  _forecastTrackingAllowed: boolean;
  notifyEmailEnabled: boolean;
  quickDeepToggleAllowed: boolean;
  quickDeepSelectorAllowed: boolean;
  signalSuggestionsEnabled: boolean;
  shiftVerdictEnabled: boolean;
  multiwayEnabled: boolean;
  copyLinksEnabled: boolean;
  autoQuestionTypeEnabled: boolean;
  orgSharingEnabled: boolean;
  allMultiwayEnabled: boolean;
  forecastLiveProgressEnabled: boolean;
  outcomeHistoryLinesEnabled: boolean;
  leadingBinAlertsEnabled: boolean;
  alternateSpacesEnabled: boolean;
  reportListenEnabled: boolean;
  dynamicReportEnabled: boolean;
  preprocessVariant: string;
};

export type FlagName = keyof Flags;

/** How an /api/me field becomes the flag's value: `=== true`, `!== false`, or a string else the default. */
export type FlagCoercion = "true" | "notFalse" | "string";

export interface ClientFlag {
  readonly name: FlagName;
  /** The /api/me field (T-12). */
  readonly meField: string;
  /** The GOFF flag key. */
  readonly key: string;
  readonly coerce: FlagCoercion;
  /** The initial value: what the hook holds before /api/me answers. */
  readonly default: boolean | string;
}

/** The client flags in /api/me projection order. */
export const CLIENT_FLAGS: readonly ClientFlag[] = Object.freeze([
  { name: "_debugUIAllowed", meField: "debugUIEnabled", key: "chatboard-debug-ui", coerce: "true", default: false },
  { name: "_forecastTrackingAllowed", meField: "forecastTrackingEnabled", key: "chatboard-forecast-tracking", coerce: "true", default: false },
  { name: "notifyEmailEnabled", meField: "notifyEmailEnabled", key: "chatboard-notify-email", coerce: "true", default: false },
  { name: "quickDeepToggleAllowed", meField: "quickDeepToggleEnabled", key: "chatboard-quick-deep-toggle", coerce: "true", default: false },
  { name: "quickDeepSelectorAllowed", meField: "quickDeepSelectorEnabled", key: "chatboard-quick-deep-selector", coerce: "true", default: false },
  { name: "signalSuggestionsEnabled", meField: "signalSuggestionsEnabled", key: "signal-panel-suggestions", coerce: "true", default: false },
  { name: "shiftVerdictEnabled", meField: "shiftVerdictEnabled", key: "chatboard-shift-verdict", coerce: "true", default: false },
  { name: "multiwayEnabled", meField: "multiwayEnabled", key: "chatboard-multiway", coerce: "true", default: false },
  { name: "copyLinksEnabled", meField: "copyLinksEnabled", key: "chatboard-copy-links", coerce: "true", default: false },
  { name: "autoQuestionTypeEnabled", meField: "autoQuestionTypeEnabled", key: "chatboard-auto-question-type", coerce: "true", default: false },
  { name: "orgSharingEnabled", meField: "orgSharingEnabled", key: "chatboard-org-sharing", coerce: "true", default: false },
  { name: "allMultiwayEnabled", meField: "allMultiwayEnabled", key: "chatboard-all-multiway", coerce: "true", default: false },
  { name: "forecastLiveProgressEnabled", meField: "forecastLiveProgressEnabled", key: "chatboard-forecast-live-progress", coerce: "true", default: false },
  { name: "outcomeHistoryLinesEnabled", meField: "outcomeHistoryLinesEnabled", key: "chatboard-outcome-history-lines", coerce: "notFalse", default: true },
  { name: "leadingBinAlertsEnabled", meField: "leadingBinAlertsEnabled", key: "chatboard-leading-bin-alerts", coerce: "true", default: false },
  { name: "alternateSpacesEnabled", meField: "alternateSpacesEnabled", key: "chatboard-alternate-spaces", coerce: "true", default: false },
  { name: "reportListenEnabled", meField: "reportListenEnabled", key: "chatboard-report-listen", coerce: "true", default: false },
  { name: "dynamicReportEnabled", meField: "dynamicReportEnabled", key: "chatboard-dynamic-report", coerce: "true", default: false },
  { name: "preprocessVariant", meField: "preprocessVariant", key: "chatboard-preprocess-variant", coerce: "string", default: "" },
]);

export const FLAG_NAMES: readonly FlagName[] = Object.freeze(CLIENT_FLAGS.map((f) => f.name));

export const FLAG_DEFAULTS: Readonly<Flags> = Object.freeze({
  _debugUIAllowed: false,
  _forecastTrackingAllowed: false,
  notifyEmailEnabled: false,
  quickDeepToggleAllowed: false,
  quickDeepSelectorAllowed: false,
  signalSuggestionsEnabled: false,
  shiftVerdictEnabled: false,
  multiwayEnabled: false,
  copyLinksEnabled: false,
  autoQuestionTypeEnabled: false,
  orgSharingEnabled: false,
  allMultiwayEnabled: false,
  forecastLiveProgressEnabled: false,
  outcomeHistoryLinesEnabled: true,
  leadingBinAlertsEnabled: false,
  alternateSpacesEnabled: false,
  reportListenEnabled: false,
  dynamicReportEnabled: false,
  preprocessVariant: "",
});

/** The flags object an /api/me body yields: every field coerced per its entry, absent ones at their default. */
export function flagsFromMe(body: unknown): Flags {
  const d = (body !== null && typeof body === "object" ? body : {}) as Record<string, unknown>;
  const out: Record<string, boolean | string> = {};
  for (const f of CLIENT_FLAGS) {
    const v = d[f.meField];
    if (f.coerce === "true") out[f.name] = v === true;
    else if (f.coerce === "notFalse") out[f.name] = v !== false;
    else out[f.name] = typeof v === "string" ? v : f.default;
  }
  return out as Flags;
}
